import Form from "../../formability/document_management/models/form";
import License from "../../formability/document_management/models/license";
import Folder from "../../formability/document_management/models/folder";
import Role from "../models/role";
import Certificate from "../../formability/document_management/models/certificate";
import ObjectModel from "../../formability/document_management/models/objectModel";
import ListView from "../models/listViews/listView";
import DetailView from "../models/detailView/detailView";
import Mapping from "../models/mapping/mapping";
import PublicProfile from "../models/publicProfile/publicProfile";
import ProcessFlow from "~/models/processFlows/processFlow";

export interface IOrganizationDocument {
  organization_id: string;
  folder_id: string;
  author: any;
  collectionKey: string;
  rootName: string;
}

export type TOrganizationDocument = Form | License | Certificate |
                                    ObjectModel | ListView | DetailView | Mapping | PublicProfile |
                                    ProcessFlow

export type TFolderDocument = Form | License | Folder |
                              Role | Certificate | ObjectModel |
                              ListView | DetailView | Mapping | PublicProfile |
                              ProcessFlow

export type TFolderDocumentKey = 'forms' | 'licenses' | 'certificates' |
  'object_models' | 'list_views' | 'detail_views' | 'mappings' | 'public_profiles' |
  'process_flows'

export type TFolderFindKey = 'folders' | TFolderDocumentKey

export const FolderDocumentFindKeyMap: { [key in TFolderDocumentKey]: string } = {
  forms: 'Form',
  licenses: "License",
  certificates: "Certificate",
  object_models: "ObjectModel",
  detail_views: "DetailView",
  list_views: "ListView",
  mappings: "Mapping",
  public_profiles: "PublicProfile",
  process_flows: "ProcessFlow",
}

export const FolderFindKeyMap: { [key in TFolderFindKey]: string } = {
  folders: 'Folder',
  ...FolderDocumentFindKeyMap
}